<template>
    <authenticator :hide-sign-up="true">
        <template v-slot:header>
            <div style="text-align: center;padding-top: 32px;">
            <img
                :src="require('@/assets/JAMB-logo-blue.svg')"
                height="60px"
            />
            </div>
        </template>
        <template v-slot:footer>
            <div style="text-align: center">
            <p class="amplify-text" >
                <em>©2024 All Rights Reserved</em>
            </p>
            </div>
        </template>
        <router-view />
    </authenticator>
</template>

<script setup>
import { watch } from 'vue';
import { Authenticator } from "@aws-amplify/ui-vue";
import { useRoute, useRouter } from 'vue-router';
import { getCurrentUser } from 'aws-amplify/auth';
const route = useRoute();
const router = useRouter();
watch(route, async () => {
    try{
        await getCurrentUser();
    }catch(error){
        router.push({ path: '/' });
    }
})
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height:100%;
  width:100%;
  background-color: #f2f5f7;
}
#app [data-amplify-authenticator] {
  align-items: center;
  background-color: #E4EBF6;
  display: flex;
  justify-content: center;
  /* height: 100%; */
  padding:48px;
  min-height: 100vh;
}
#app [data-amplify-authenticator] div#description {
  background-color: #ffffff;
  width: 200px;
  padding: 35px;
}
#app [data-amplify-authenticator] > [data-amplify-container] {
  background-color: #fff;
}
div[data-amplify-router] {
  border: none !important;
  box-shadow: none !important;
}
[data-amplify-container] {
  border-radius: 5px;
  box-shadow: 0px 0px 24px 0 #AEC2E5;
  /* color: #ecf0f1; */
  padding: 35px;
}
#app [data-amplify-authenticator] [data-amplify-container] label {
  /* color: #95a5a6; */
  font-size: 0.8em;
}
#app [data-amplify-authenticator] [data-amplify-container] button:hover {
  background-color: #eeeeee;
}
.amplify-label{
  text-align:left;
}
.amplify-authenticator__subtitle {
  text-align:left;
  color:#999999;
}
.amplify-button--primary,
.amplify-button--link {
  background-color: #305597 !important;
  color: #ffffff !important;
}
.amplify-text {
  font-size: 12px;
}
.amplify-phonenumberfield input {
  border-radius: 4px !important;
}
.v-field__loader {
    display: none;
}
@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.v-field--loading .mdi-loading {
    animation: spin 1s linear infinite;
    opacity: 1;
}
</style>
